/**
 * All icon names that are supported by the component.
 */
export enum IconName {
    FOLDER = 'Folder',
    X = 'X',
    ADD = 'Add',
    ADD_OUTLINED = 'AddOutlined',
    DELETE = 'Delete',
    REMOVE = 'Remove',
    MORE_HORIZONTAL = 'MoreHorizontal',
    PIN = 'PinReportIcon.svg',
    PINNED = 'PinnedReportIcon.svg',
    FEEDBACK = 'FeedbackIcon.svg',
    MOREOPTIONS = 'MoreOptionsIcon.svg',
    ERRORCIRCLE = 'ErrorCircle',
    INFO = 'Info',
    SUCCESS = 'SuccessTick',
    EMAIL = 'Email',
    HOME = 'HomeIcon',
    REPORT = 'Report',
    FILTER = 'Filter',
    FIELDS = 'Fields',
    DASHBOARD = 'Dashboard',
    LAYER = 'Layer',
    ALARM = 'Alarm',
    SCHEDULE = 'Schedule',
    MONEY = 'Money',
    SETTINGS = 'Settings',
    WRENCH = 'Wrench',
    ARROW_BACK = 'ArrowBack',
    ARROW_LEFT = 'ArrowLeft',
    ARROW_RIGHT = 'ArrowRight',
    DOUBLE_ARROW_LEFT = 'DoubleArrowLeft',
    DOUBLE_ARROW_RIGHT = 'DoubleArrowRight',
    ARROW_UP = 'ArrowUp',
    ARROW_DOWN = 'ArrowDown',
    UNFOLD_ALL = 'Unfold',
    FOLD_ALL = 'Fold',
    RECORDING = 'Recording',
    CHECKBOX_BLANK = 'CheckBoxBlank',
    CHECKBOX_CHECKED = 'CheckBoxChecked',
    CHECKBOX_MINUS = 'CheckBoxMinus',
    ARROW_DROPDOWN = 'ArrowDropDown',
    ARROW_DROPUP = 'ArrowDropUp',
    PRINT = 'Print',
    RATING = 'Rating',
    PENCIL = 'Pencil',
    OTHER = 'Other',
    TAG = 'Tag',
    SORT = 'Sort',
    HELP = 'Help',
    COPY = 'Copy',
    PAUSE = 'Pause',
    PLAY = 'Play',
    DOWNLOAD = 'Download',
    OPEN_IN_NEW = 'OpenInNewOutlined',
    CLOSE_FROM_WINDOW = 'PopinOutline',
    CONFIGURE = 'Configure',
    LANGUAGE = 'Language',
    DEVICEHUB = 'DeviceHub',
    CHANGE = 'Change',
    CHOOSE = 'Choose',
    DRAG = 'DragIndicator',
    DASHBOARD_ADD = 'DashboardAddReport',
    DELETE_SWEEP = 'DeleteSweep',
    DELETE_FOREVER = 'DeleteForever',
    RESTORE_FROM_TRASH = 'RestoreFromTrash',
    WARNING = 'Warning',
    SYNC = 'Sync',
    CHECK = 'Check',
    PROVISIONING = 'Provisioning',
    VISIBLE = 'Visibility',
    VISIBLE_OFF = 'VisibilityOff',
    PERSON = 'PersonOutlined',
    LOCKED = 'LockOutlined',
    PHONE = 'PhoneEnabledOutlined',
    ADMIN = 'AdminIcon',
    DICE = 'Casino',
    ROLE = 'Role',
    CUSTOMISE_ROLE = 'CustomiseRole',
    HOW_TO = 'HowTo',
    TOOLS = 'Tools',
    PASSWORD_RANDOMISE = 'PasswordRandomise',
    PIN_NUM_OUTLINED = 'PinNumOutlined',
    GPS_FIXED_OUTLINED = 'GpsFixedOutlinedIcon',
    PARTITION = 'Partition',
    TELSERVER = 'TelServer',
    HASH_TAG = 'HashTag',
    OMNICHANNEL = 'OmniChannel',
    TODAY = 'Today',
    CLOCK = 'Clock',
    ARROW = 'Arrow',
    NUM_PAD = 'NumPad',
    INBOUND_CALL = 'InboundCall',
    DEVICE_INFO = 'DeviceInfo',
    RATE_REVIEW = 'RateReview',
    FIRST_PAGE = 'FirstPage',
    LAST_PAGE = 'LastPage',
    CHEVRON_RIGHT = 'ChevronRight',
    CHEVRON_LEFT = 'ChevronLeft',
    QUESTION_MARK = 'QuestionMark',
    TOUR = 'Tour',
    NOTIFICATION_ADD = 'NotificationAddOutlined',
    NOTIFICATION_ENABLED = 'NotificationsNoneOutlined',
    NOTIFICATION_DISABLED = 'NotificationsOffOutlined',
    LIBRARY_ADD_OUTLINED = 'LibraryAddOutlinedIcon',
    ROLE_ADD = 'RoleAdd',
    TELSYS_DETAILS = 'TelSysDetails',
    SETTINGS_SUGGEST = 'SettingsSuggest',
    TELSYS_COMMUNICATIONS = 'TelSysCommunications',
    NOT_LINKED = 'NotLinked',
    LINKED = 'Linked',
    SEND = 'Send',
    LICENCES = 'Licences',
    ADD_ALL = 'AddAll',
    PROVISION_ALL_CXI = 'ProvisionAllCxi',
    ADD_CIRCLE = 'AddCircle',
    DEPARTMENT = 'Department',
    STATUS = 'Status',
    SORTING_AZ = 'SortingAZ',
    SORTING_ZA = 'SortingZA',
    INSIGHTS_HUB_OFF = 'InsightsHubOff',
    INSIGHTS_HUB_ON = 'InsightsHubOn',
    MODULE = 'Module',
    APPS = 'Apps',
    API_KEYS = 'APIKeys',
    DARK_MODE = 'DarkMode',
    LIGHT_MODE = 'LightMode',
    LOGOUT = 'Logout',
    REMOVE_FROM_QUEUE = 'RemoveFromQueue',
    MENU_LAUNCHER = 'MenuLauncher',
    HELP_AVATAR_MENU = 'HelpAvatarMenu',
    CHANGE_LANGUAGE = 'ChangeLanguage',
    CHANGE_PASSWORD = 'ChangePassword',
    HIDE_INSIGHTS = 'HideInsights',
    SHOW_INSIGHTS = 'ShowInsights',
    REPORTING = 'Reporting',
    FAST_PROVISIONING = 'FastProvisioning',
    ADMINISTRATION = 'Admin',
    STATUS_TOOLS = 'StatusTools',
    REPORTING_SIDEBAR = 'ReportingSidebar',
    INSIGHTS_SIDEBAR = 'InsightsSidebar',
    PRESENCE_SIDEBAR = 'PresenceSidebar',
    USER_MANAGEMENT_SIDEBAR = 'UserManagementSidebar',
    QUEUE_MANAGEMENT_SIDEBAR = 'QueueManagementSidebar',
    ENTERPRISE_MANAGEMENT_SIDEBAR = 'EnterpriseManagementSidebar',
    DEVICES_SIDERBAR = 'DevicesSidebar',
    PARTITIONS_SIDEBAR = 'PartitionsSidebar',
    TELSERVERS_SIDEBAR = 'TelServersSidebar',
    RECORDINGS_SIDEBAR = 'RecordingsSidebar',
    USERS_SIDEBAR = 'UsersSidebar',
    CME_SIDEBAR = 'CMESidebar',
    CODES_SIDEBAR = 'CodesSidebar',
    DIRECTORY_SIDEBAR = 'DirectorySidebar',
    MESSAGE_SIDEBAR = 'MessageSidebar',
    DATABASE_SIDEBAR = 'DatabaseSidebar',
    AGENTS_SIDEBAR = 'AgentsSidebar',
    LICENCES_SIDEBAR = 'LicencesSidebar',
    LOG_MANAGEMENT_SIDEBAR = 'LogManagementSidebar',
    SERVER_STATUS_SIDEBAR = 'ServerStatusSidebar',
    LOGGING_SIDEBAR = 'LoggingSidebar',
    AUDIT_LOGS_SIDEBAR = 'AuditLogsSidebar',
    TELSYS_MODULE_STATUS_SIDEBAR = 'TelSysModuleStatusSidebar',
    CALL_CONTROL_SIDEBAR = 'CallControlSidebar',
    CLIENT_CONFIGURATION_SIDEBAR = 'ClientConfigurationSidebar',
    CRM_CONFIGURATION_SIDEBAR = 'CRMConfigurationSidebar',
    EXPAND_MENU = 'ExpandMenu',
    COLLAPSE_MENU = 'CollapseMenu',
    FAVOURITE = 'Favourite',
    FAVOURITE_OUTLINED = 'FavouriteOutlined',
    MISSED_CALLS = 'MissedCalls',
    CALLS_RECEIVED = 'CallsReceived',
    AVERAGE_ANSWER = 'AverageAnswer',
    AVERAGE_ABANDONED = 'AverageAbandoned',
    LONGEST_WAIT = 'LongestWait',
    QUEUE_MONITOR_ALL = 'QueueMonitorAll',
    QUEUE_UNMONITOR_ALL = 'QueueUnmonitorAll',
    BRANDING = 'Branding',
    BELL = 'Bell',
    TIMEZONE = 'TimeZone',
    ABANDONED_CALL = 'AbandonedCall',
    ADVANCED_BOUNCED_CALL = 'AdvancedBouncedCall',
    ANSWERED_CALL = 'AnsweredCall',
    CALL_ENDED_CALL = 'CallEndedCall',
    CALL_STARTED_INBOUND_CALL = 'CallStartedInboundCall',
    CALL_STARTED_OUTBOUND_CALL = 'CallStartedOutboundCall',
    CONFERENCED_CALL = 'ConferencedCall',
    DIVERTED_CALL = 'DivertedCall',
    ENDED_ON_HOLD_CALL = 'EndedOnHoldCall',
    ESCAPE_CALL = 'EscapeCall',
    MOVED_CALL = 'MovedCall',
    OVERFLOWED_CALL = 'OverflowedCall',
    TRANSFERRED_CALL = 'TransferredCall',
    UNMONITORED_UNKNOWN_DESTINATION_CALL = 'UnmonitoredUnknownDestinationCall',
    REPLAY = 'Replay',
    PREVIEW = 'Preview',
    DELETE_PREVIEW = 'DeletePreview',
    CLEAR_CHANGES = 'ClearChanges',
    REFRESH = 'Refresh',
    POLICY = 'Policy',
    SETTINGS_CONFIG = 'SettingsConfig',
    TENANT = 'Tenant',
    SECURITY_GROUPS = 'SecurityGroups',
    CX_SCORE = 'CXScore',
    CX_ANALYTICS = 'CXAnalytics'
}

/**
 * All icon sizes that are supported by the component.
 */
export enum IconSize {
    SMALL = 'small-icon',
    MEDIUM = 'medium-icon',
    LARGE = 'large-icon',
    GIANT = 'giant-icon'
}
